import React from 'react';
import Button from '../../generic/inputs/simpleComponents/Button';
import './SimpleModal.scss';
const SimpleModal = ({
  showModal,
  title,
  subtitle,
  children,
  onCancel,
  onCancelLabel = 'Annulla',
  onSubmit,
  onSubmitLabel = 'Conferma',
  classes = {}
}) => {
  const handleOnCancel = e => {
    e.stopPropagation();
    e.preventDefault();
    onCancel();
  };
  const handleOnSubmit = e => {
    e.stopPropagation();
    e.preventDefault();
    onSubmit();
  };
  return showModal ? /*#__PURE__*/React.createElement("div", {
    className: `simple-modal-overlay ${classes.overlay}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `simple-modal-card ${classes.card}`
  }, /*#__PURE__*/React.createElement("div", {
    onClick: handleOnCancel,
    className: `simple-modal-close-icon ${classes.closeIcon}`
  }, /*#__PURE__*/React.createElement("span", {
    className: `icon cross-black small`
  })), /*#__PURE__*/React.createElement("div", {
    className: `simple-modal-title ${classes.title}`
  }, title), /*#__PURE__*/React.createElement("div", {
    className: `simple-modal-subtitle ${classes.subtitle}`
  }, subtitle), /*#__PURE__*/React.createElement("div", {
    className: `simple-modal-body ${classes.body}`
  }, children), /*#__PURE__*/React.createElement("div", {
    className: `simple-modal-actions ${classes.actions}`
  }, /*#__PURE__*/React.createElement(Button, {
    inverted: true,
    onClick: handleOnCancel
  }, onCancelLabel), /*#__PURE__*/React.createElement(Button, {
    onClick: handleOnSubmit
  }, onSubmitLabel)))) : '';
};
export default SimpleModal;